import axios from "axios";
import {apiURL,makeFormData,lowerCaseKeys,createDictionary} from "../../utilities/utilityFunctions";
import {updateGameTime} from "src/actions/gameTime";
import store from 'src/store';
import {appSettingModel} from "src/datamodels/foundation";
import {obtainUser} from "src/containers/permissions/permissionFunctions";

export const createQuickInvitation = (formdata,callBack,fail) => {
    axios.post(apiURL() + "/invitations/quickcreate",makeFormData({invitation:formdata}),{headers: {
            "Authorization": "Bearer " + obtainUser(),
            "DomainCode":appSettingModel().domainCode,
            "OffsetTime":(new Date()).getTimezoneOffset()
        }}).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};


export const createInvitation = (formdata,callBack,fail) => {
    axios.post(apiURL() + "/invitations/create",makeFormData({invitation:formdata}),{headers: {
            "Authorization": "Bearer " + obtainUser(),
            "DomainCode":appSettingModel().domainCode
        }}).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};

export const addListToRoom = (props,formdata,callBack,fail) => {
    axios.post(apiURL(props) + "/rooms/addList",makeFormData({invitation:formdata}),{headers: {
            "Authorization": "Bearer " + obtainUser(props)
        }}).then((evt)=>callBack(props,evt)).catch((evt)=>fail(props,evt));
};

let mediaTypeCount = 0;
let mediaTypeInt = {};
export const obtainMediaTypes = () => {
    axios.get(apiURL() + "/gameTime/mediatypes").then((evt)=>{
        mediaTypeCount=0;
        clearTimeout(mediaTypeInt);
        let res=lowerCaseKeys(evt.data);
        let typeDict=createDictionary(res,"mediatypeid");
        store.dispatch(updateGameTime({"mediaTypes":res,"mediaTypeDict":Object.assign({},typeDict)}));
    }).catch((evt)=>{
        console.dir("back fail");
        console.dir(evt);
        mediaTypeInt = setTimeout(()=>{
            mediaTypeCount=mediaTypeCount+1;
            obtainMediaTypes();
        },3000)
    });
};




let listCount=0;
let listIn = {};

export const obtainMyLists =() => {
    clearTimeout(listIn);
    axios.get(apiURL() + "/users/lists",{
        headers: {
            "Authorization": "Bearer " + obtainUser()
        }
    }).then((evt)=>{
        listCount=0;
        clearTimeout(listIn);
        let lists=lowerCaseKeys(evt.data);
        let listDict=createDictionary(lists,"mylistid");
        store.dispatch(updateGameTime({myLists:lists,myListDict:listDict}));
    }).catch(()=>{
        listCount = listCount+1;
        if(listCount <= 3) {
            listIn = setTimeout(() => {
                obtainMyLists();
            }, 3000)
        }
    });
};

export const saveList = (props,formdata,callBack,fail) => {
    axios.post(apiURL(props) + "/media/list/save",makeFormData({list:JSON.stringify(formdata)}),{headers: {
            "Authorization": "Bearer " + obtainUser()
        }}).then((evt)=>callBack(props,evt)).catch((evt)=>fail(props,evt));
};

export const obtainMyRooms = (callBack,fail) => {
    axios.get(apiURL() + "/users/rooms",{headers: {
            "Authorization": "Bearer " + obtainUser()
        }}).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};

export const obtainMySettings = (callBack,failFunc) => {
    axios.get(apiURL() + "/users/settings",{headers: {
            "Authorization": "Bearer " + obtainUser()
        }}).then((evt)=>callBack(evt)).catch((evt)=>failFunc(evt));
};

export const obtainMyMedia = (callBack,fail) => {
    axios.get(apiURL() + "/media/",{headers: {
            "Authorization": "Bearer " + obtainUser()
        }}).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};

export const obtainMyMediaByList = (listid, callBack,fail) => {
    axios.get(apiURL() + "/media/listMedia/" + listid,{headers: {
            "Authorization": "Bearer " + obtainUser()
        }}).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};

export const obtainMyMediaById = (mediaid, callBack,fail) => {
    axios.get(apiURL() + "/media/" + mediaid,{headers: {
            "Authorization": "Bearer " + obtainUser()
        }}).then((evt)=>callBack(evt,mediaid)).catch((evt)=>fail(evt,mediaid));
};

export const loadMediaByType = (types,callBack,fail) => {
    axios.post(apiURL() + "/media/filter",makeFormData({types:types}),{"headers": {
            "Authorization": "Bearer " + obtainUser(),
            "DomainCode":appSettingModel().domainCode
        }}).then((evt)=>{callBack(evt)}).catch((evt)=>{fail(evt)});
};

export const uploadNewQuizRunner = (props,formData,callBack,fail) => {
    axios.post(apiURL(props) + "/media/quizRunner",formData,{headers: {
            "Authorization": "Bearer " + obtainUser(props),
            'Content-Type': 'multipart/form-data'
        }}
    ).then((evt)=>callBack(props,evt)).catch((evt)=>fail(props,evt));
};

export const obtainListData= (listid, callBack,fail) => {
    //let lister=listid ? listid : props.gameTime?.chosenList ? props.gameTime.chosenList : '';
    if(listid) {
        axios.get(apiURL() + "/media/listData/" + listid, {
                headers: {
                    "Authorization": "Bearer " + obtainUser(),
                }
            }
        ).then((evt) => callBack(evt)).catch((evt) => fail(evt));
    }
    else{
        console.dir("No list submitted to obtain ListData");
    }
};

export const obtainMyActivites = (callBack,fail) => {
    axios.get(apiURL() + "/gameTime/myactivities",{headers: {
            "Authorization": "Bearer " + obtainUser(),
            "DomainCode":appSettingModel().domainCode
        }}).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};

export const obtainMyPermissions = (callBack,fail) => {
    axios.get(apiURL() + "/gameTime/mypermissions",{headers: {
            "Authorization": "Bearer " + obtainUser(),
            "DomainCode":appSettingModel().domainCode
        }}).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};

export const listsByActivity = (activityCode,callBack,fail) => {
    axios.get(apiURL() + "/media/lists/activity/" + activityCode,{headers: {
            "Authorization": "Bearer " + obtainUser(),
            "DomainCode":appSettingModel().domainCode
        }}).then((evt)=>callBack(activityCode,evt)).catch((evt)=>fail(activityCode,evt));
};

export const goGetMetaData = (mediaid,callBack,fail) => {
    axios.get(apiURL() + "/media/" + mediaid + "/metadata",{headers: {
            "Authorization": "Bearer " + obtainUser(),
            "DomainCode":appSettingModel().domainCode
        }}).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};

export const obtainConvoContent = (type,callBack,fail) => {
    axios.get(apiURL() + "/games/conversation/" + type,{headers: {
            "Authorization": "Bearer " + obtainUser(),
            "DomainCode":appSettingModel().domainCode
        }}).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};

export const regActivityplay = (formData,callBack,fail) => {
    let headers = {"DomainCode":appSettingModel().domainCode};
    headers.Authorization = obtainUser() !=='' ? obtainUser() : null;


    axios.post(apiURL() + "/gametime/regActivity",makeFormData(formData),{headers: headers}).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};

export const addUserPoll = (pollData,callBack,fail)=>{
    axios.post(apiURL() + "/gametime/addUserPoll",makeFormData(pollData),{headers: {
            "Authorization": "Bearer " + obtainUser(),
            "DomainCode":appSettingModel().domainCode
        }}).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};
